import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';
import CompareChartScreen from '../screens/examples/CompareChartScreen';
import DataTrackerChartScreen from '../screens/examples/DataTrackerChartScreen';
import GaugeChartScreen from '../screens/examples/GaugeChartScreen';
import RollingAverageChartExampleScreen from '../screens/examples/RollingAverageChartExampleScreen';
import { getScreenOptions } from './getScreenOptions';
import AppHeader from '../components/AppHeader';
import PainStudyResultsExampleScreen from '../screens/examples/study/pain/PainStudyResultsExampleScreen';
import SleepStudyResultsExampleScreen from '../screens/examples/study/sleep/SleepStudyResultsExampleScreen';
import SurveyFromDateInputExampleScreen from '../screens/examples/SurveyFormDateInputExampleScreen';
import TestDynamicFormScreen from '../screens/examples/TestDynamicFormScreen';
import ExampleScreen from '../screens/examples/ExampleScreen';
import ExampleButtonScreen from '../screens/examples/ExampleButtonScreen';
import CalendarScreen from '../screens/calendar/CalendarScreen';
import TimePickerScreen from '../screens/examples/TimePickerScreen';
import HealthKitGoogleFitSampleScreen from '../screens/examples/HealthKitGoogleFitSampleScreen';
import StudyNotificationListExampleScreen from '../screens/examples/StudyNotificationListExampleScreen';
import TodayEmptyStateScreen from '../screens/examples/TodayEmptyStateScreen';
import CalendarDayScrollExampleScreen from '../screens/examples/CalendarDayScrollExampleScreen';
import StudyJourneyChartScreen from '../screens/examples/StudyJourneyChartScreen';
import WellnessCategoryListScreen from '../screens/examples/WellnessCategoryListScreen';
import ExampleListScreen from '../screens/examples/ExampleListScreen';
import DiscoverCategoryListExampleScreen from '../screens/examples/DiscoverCategoryListExampleScreen';
import PromptListExampleScreen from '../screens/examples/PromptListExampleScreen';
import WebViewModalExampleScreen from '../screens/examples/WebViewModalExampleScreen';
import ExampleStudyCardScreen from '../screens/examples/ExampleStudyCardScreen';
import EncouragementViewExampleScreen from '../screens/examples/EncouragementViewExampleScreen';
import ExampleHeaderTabViewScreen from '../screens/examples/ExampleHeaderTabViewScreen';
import HealthConnectSampleDataScreen from '../screens/examples/HealthConnectSampleDataScreen';

export type ExamplesParamList = {
  ExampleScreen: undefined;
  CompareChartScreen: undefined;
  DataTrackerChartScreen: undefined;
  GaugeChartScreen: undefined;
  TestDynamicFormScreen: undefined;
  CalendarScreen: undefined;
  RollingAverageChartExampleScreen: undefined;
  SurveyFormDateInput: undefined;
  Study1ResultsExampleScreen: undefined;
  ExampleButtonScreen: undefined;
  ExampleListScreen: undefined;
  SleepStudyResultsExampleScreen: {
    title: string;
    subTitle: string;
    studyNumber: number;
  };
  PainStudyResultsExampleScreen: {
    title: string;
    subTitle: string;
    studyNumber: number;
  };
  TimePickerScreen: undefined;
  HealthKitGoogleFitSampleScreen: undefined;
  HealthConnectSampleDataScreen: undefined;
  StudyNotificationListExampleScreen: undefined;
  TodayEmptyStateScreen: undefined;
  CalendarDayScrollExampleScreen: undefined;
  StudyJourneyChartScreen: undefined;
  DiscoverCategoryListExampleScreen: undefined;
  WellnessCategoryListScreen: undefined;
  PromptListExampleScreen: undefined;
  WebViewModalExampleScreen: undefined;
  StudyCardScreen: undefined;
  EncouragementViewExampleScreen: undefined;
  ExampleHeaderTabViewScreen: undefined;
};

const ExamplesStack = createStackNavigator<ExamplesParamList>();

export default function ExamplesNavigator() {
  return (
    <ExamplesStack.Navigator
      initialRouteName='ExampleScreen'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => <AppHeader />,
        headerShown: true,
        gestureEnabled: false
      })}
    >
      <ExamplesStack.Screen name='ExampleScreen' component={ExampleScreen} />
      <ExamplesStack.Screen
        name='CompareChartScreen'
        component={CompareChartScreen}
      />
      <ExamplesStack.Screen
        name='DataTrackerChartScreen'
        component={DataTrackerChartScreen}
      />
      <ExamplesStack.Screen
        name='GaugeChartScreen'
        component={GaugeChartScreen}
      />
      <ExamplesStack.Screen name='CalendarScreen' component={CalendarScreen} />
      <ExamplesStack.Screen
        name='RollingAverageChartExampleScreen'
        component={RollingAverageChartExampleScreen}
      />
      <ExamplesStack.Screen
        name='SurveyFormDateInput'
        component={SurveyFromDateInputExampleScreen}
      />
      <ExamplesStack.Screen
        name='TestDynamicFormScreen'
        component={TestDynamicFormScreen}
      />
      <ExamplesStack.Screen
        name='ExampleButtonScreen'
        component={ExampleButtonScreen}
      />
      <ExamplesStack.Screen
        name='ExampleListScreen'
        component={ExampleListScreen}
      />
      <ExamplesStack.Screen
        name='PainStudyResultsExampleScreen'
        component={PainStudyResultsExampleScreen}
      />
      <ExamplesStack.Screen
        name='SleepStudyResultsExampleScreen'
        component={SleepStudyResultsExampleScreen}
      />
      <ExamplesStack.Screen
        name='TimePickerScreen'
        component={TimePickerScreen}
      />
      <ExamplesStack.Screen
        name='HealthKitGoogleFitSampleScreen'
        component={HealthKitGoogleFitSampleScreen}
      />
      <ExamplesStack.Screen
        name='HealthConnectSampleDataScreen'
        component={HealthConnectSampleDataScreen}
      />
      <ExamplesStack.Screen
        name='StudyNotificationListExampleScreen'
        component={StudyNotificationListExampleScreen}
      />
      <ExamplesStack.Screen
        name='TodayEmptyStateScreen'
        component={TodayEmptyStateScreen}
      />
      <ExamplesStack.Screen
        name='CalendarDayScrollExampleScreen'
        component={CalendarDayScrollExampleScreen}
      />
      <ExamplesStack.Screen
        name='StudyJourneyChartScreen'
        component={StudyJourneyChartScreen}
      />
      <ExamplesStack.Screen
        name='DiscoverCategoryListExampleScreen'
        component={DiscoverCategoryListExampleScreen}
      />
      <ExamplesStack.Screen
        name='WellnessCategoryListScreen'
        component={WellnessCategoryListScreen}
      />
      <ExamplesStack.Screen
        name='PromptListExampleScreen'
        component={PromptListExampleScreen}
      />
      <ExamplesStack.Screen
        name='WebViewModalExampleScreen'
        component={WebViewModalExampleScreen}
      />
      <ExamplesStack.Screen
        name='StudyCardScreen'
        component={ExampleStudyCardScreen}
      />
      <ExamplesStack.Screen
        name='EncouragementViewExampleScreen'
        component={EncouragementViewExampleScreen}
      />
      <ExamplesStack.Screen
        name='ExampleHeaderTabViewScreen'
        component={ExampleHeaderTabViewScreen}
      />
    </ExamplesStack.Navigator>
  );
}
